// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".address-form{max-width:600px;margin:0 auto}.address-form__zip{max-width:225px}.address-form__number{align-items:center}", ""]);
// Exports
module.exports = exports;
